import { combineReducers } from 'redux';

import UnitHome from './UnitHome';
import PreventiveTask from './PreventiveTask';
import PreventiveTaskAssignee from './PreventiveTaskAssignee';
import PreventiveTaskExecution from './PreventiveTaskExecution';
import PreventiveTaskProjection from './PreventiveTaskProjection';
import CompanyResource from './CompanyResource';
import CompanyResourceGroup from './CompanyResourceGroup';

export default combineReducers({
  UnitHome,
  CompanyResource,
  CompanyResourceGroup,
  PreventiveTask,
  PreventiveTaskAssignee,
  PreventiveTaskExecution,
  PreventiveTaskProjection,
});
